"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.narrow = void 0;
function narrow(value) {
    return value;
}
exports.narrow = narrow;
//# sourceMappingURL=narrow.js.map